module.exports = __webpack_public_path__ + "img/組織追加.14bfe1bb.png";